export default __webpack_public_path__ + "static/media/Brown.103f2c01.gif";